module.exports = __webpack_public_path__ + "img/scrm_ui_4.03d5554b.png";